import { createColumnHelper } from '@tanstack/react-table'
import { NavLink } from 'react-router-dom'
import formate from 'date-format'
import ActionButton from '../../components/shared/ActionButton'
import { ViewIcon } from '../../components/shared/Icons'
import { formatQuoteType } from '../Quotes/COLUMNS'

const columnHelper = createColumnHelper()

export const columns = [
  columnHelper.accessor('quoteType', {
    header: 'Quote Type',
    cell: (info) => formatQuoteType(info.getValue()),
  }),
  columnHelper.accessor('customerInfo', {
    header: 'Customer',
    cell: (info) => info.getValue()?.name || '-',
  }),
  columnHelper.accessor('customerInfo.email', {
    header: 'Email',
    cell: (info) => info.getValue() || '-',
  }),
  columnHelper.accessor('pricing.selectedDeliveryOption.label', {
    header: 'Build Time',
    cell: (info) => info.getValue() || info.row.original?.pricing?.leadTimeDays || '-',
  }),
  columnHelper.accessor('pricing.totalAmount', {
    header: 'Total',
    cell: (info) => `$${Number(info.getValue() || 0).toFixed(2)}`,
  }),
  columnHelper.accessor('pricing.shippingMethod', {
    header: 'Shipping',
    cell: (info) => info.getValue() || '-',
  }),
  columnHelper.accessor('reviewFlags', {
    header: 'Review Flags',
    cell: (info) => (info.getValue() || []).join(', ') || '-',
  }),
  columnHelper.accessor('createdAt', {
    header: 'Calculated At',
    cell: (info) => formate.asString('dd/MM/yyyy HH:mm', new Date(info.getValue())),
  }),
  columnHelper.accessor('_id', {
    id: 'View',
    header: <span className="opacity-0">View</span>,
    cell: (info) => (
      <NavLink to={`/quote-calculations/view/${info.getValue()}`}>
        <ActionButton>
          <ViewIcon />
          View
        </ActionButton>
      </NavLink>
    ),
  }),
]
